import { authService } from '../services/authService.js';
import { Toast } from './Toast.js';

export function openAuthModal(onSuccess) {
  const backdrop = document.createElement('div');
  backdrop.className = 'sheet-backdrop active';

  backdrop.innerHTML = `
    <div class="bottom-sheet" style="max-width: 440px;" role="dialog">
      <div class="sheet-handle"></div>

      <div style="text-align: center; margin-bottom: var(--space-md);">
        <h3 style="font-size: 1.3rem; font-weight: 800; margin-bottom: 4px;">CinemaHala Account</h3>
        <p style="color: var(--text-secondary); font-size: 0.85rem;">Sign in to save ratings, write reviews, and join discussions</p>
      </div>

      <!-- Quick Demo Login Presets -->
      <div style="background: var(--bg-surface); border: 1px solid var(--border-gold); border-radius: var(--radius-md); padding: 12px; margin-bottom: var(--space-md);">
        <span style="display: block; font-size: 0.75rem; font-weight: 700; color: var(--accent-gold); text-transform: uppercase; margin-bottom: 8px;">
          ⚡ Quick Demo Login
        </span>
        <div style="display: flex; gap: var(--space-xs);">
          <button type="button" id="demo-admin-btn" class="btn-primary clickable-item" style="flex: 1; padding: 7px 10px; font-size: 0.8rem;">
            👑 Demo Admin
          </button>
          <button type="button" id="demo-member-btn" class="btn-secondary clickable-item" style="flex: 1; padding: 7px 10px; font-size: 0.8rem;">
            🎬 Demo Member
          </button>
        </div>
      </div>

      <!-- Tabs -->
      <div style="display: flex; border-bottom: 1px solid var(--border-subtle); margin-bottom: var(--space-md);">
        <button id="tab-login" class="desktop-nav-link active" style="flex: 1; text-align: center; border-radius: 0; border-bottom: 2px solid var(--accent-gold); color: var(--accent-gold);">
          Sign In
        </button>
        <button id="tab-register" class="desktop-nav-link" style="flex: 1; text-align: center; border-radius: 0;">
          Create Account
        </button>
      </div>

      <!-- Login Form -->
      <form id="auth-form" style="display: flex; flex-direction: column; gap: var(--space-md);">
        <div id="name-field-wrap" style="display: none;">
          <label style="display: block; font-size: 0.8rem; font-weight: 700; margin-bottom: 4px;">Your Name</label>
          <input type="text" id="auth-name" placeholder="Kasun Perera" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
        </div>

        <div>
          <label style="display: block; font-size: 0.8rem; font-weight: 700; margin-bottom: 4px;">Email Address</label>
          <input type="email" id="auth-email" required placeholder="dmsameeram@gmail.com" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
        </div>

        <div>
          <label style="display: block; font-size: 0.8rem; font-weight: 700; margin-bottom: 4px;">Password</label>
          <input type="password" id="auth-password" placeholder="••••••••" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
        </div>

        <button type="submit" id="auth-submit-btn" class="btn-primary clickable-item" style="width: 100%; padding: 12px; font-size: 0.95rem;">
          Sign In to CinemaHala
        </button>

        <button type="button" id="auth-cancel-btn" class="btn-secondary clickable-item" style="width: 100%; padding: 10px; font-size: 0.88rem;">
          Cancel
        </button>
      </form>
    </div>
  `;

  let mode = 'login';
  const nameWrap = backdrop.querySelector('#name-field-wrap');
  const submitBtn = backdrop.querySelector('#auth-submit-btn');
  const tabLogin = backdrop.querySelector('#tab-login');
  const tabRegister = backdrop.querySelector('#tab-register');
  const emailInput = backdrop.querySelector('#auth-email');
  const nameInput = backdrop.querySelector('#auth-name');
  const form = backdrop.querySelector('#auth-form');

  function setMode(newMode) {
    mode = newMode;
    if (mode === 'login') {
      nameWrap.style.display = 'none';
      submitBtn.textContent = 'Sign In to CinemaHala';
      tabLogin.classList.add('active');
      tabLogin.style.borderBottom = '2px solid var(--accent-gold)';
      tabLogin.style.color = 'var(--accent-gold)';
      tabRegister.classList.remove('active');
      tabRegister.style.borderBottom = 'none';
      tabRegister.style.color = 'var(--text-secondary)';
    } else {
      nameWrap.style.display = 'block';
      submitBtn.textContent = 'Create Free Account';
      tabRegister.classList.add('active');
      tabRegister.style.borderBottom = '2px solid var(--accent-gold)';
      tabRegister.style.color = 'var(--accent-gold)';
      tabLogin.classList.remove('active');
      tabLogin.style.borderBottom = 'none';
      tabLogin.style.color = 'var(--text-secondary)';
    }
  }

  tabLogin.addEventListener('click', () => setMode('login'));
  tabRegister.addEventListener('click', () => setMode('register'));

  // Quick Demo Buttons
  backdrop.querySelector('#demo-admin-btn').addEventListener('click', () => {
    emailInput.value = 'dmsameeram@gmail.com';
    const user = authService.login('dmsameeram@gmail.com');
    Toast.show(`Signed in as ${user.name} (Admin Role)`, 'success');
    close();
    if (onSuccess) onSuccess(user);
  });

  backdrop.querySelector('#demo-member-btn').addEventListener('click', () => {
    emailInput.value = 'kasun@cinemahala.lk';
    const user = authService.login('kasun@cinemahala.lk');
    Toast.show(`Signed in as ${user.name} (Member)`, 'success');
    close();
    if (onSuccess) onSuccess(user);
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const email = emailInput.value.trim();
    if (!email) return;

    let user;
    if (mode === 'login') {
      user = authService.login(email);
      Toast.show(`Welcome back, ${user.name}!`, 'success');
    } else {
      user = authService.register(email, nameInput.value.trim());
      Toast.show(`Account created for ${user.name}!`, 'success');
    }

    close();
    if (onSuccess) onSuccess(user);
  });

  function close() {
    backdrop.classList.remove('active');
    setTimeout(() => backdrop.remove(), 250);
  }

  backdrop.querySelector('#auth-cancel-btn').addEventListener('click', close);
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });

  document.body.appendChild(backdrop);
}
